import type { BBUiConfig } from 'types/story';
import createGenericContext from 'common/components/CreateGenericContext';

export type TransitionEndProps = {
	_id: string;
	type: string;
	in: boolean | undefined;
	uiConfig: BBUiConfig;
};

export type TransitionHandlerContextType = {
	in?: boolean;
	onTransitionEnd: (props: TransitionEndProps) => void;
};

export const [
	useCardTransitionContext,
	CardTransitionContextProvider,
	CardTransitionContextConsumer,
	withCardTransitionContext,
] = createGenericContext<Partial<TransitionHandlerContextType>>({
	in: undefined,
});
